// src/components/CarLoan.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CarLoan.css';

const CarLoan = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    loanAmount: '500000',
    tenure: '5',
    employmentType: 'salaried',
    income: '',
    name: '',
    email: '',
    phone: '',
    city: '',
    carPrice: ''
  });

  const handleGoBack = () => {
    navigate('/home');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Application submitted successfully! Our representative will contact you shortly.');
    setFormData({
      loanAmount: '500000',
      tenure: '5',
      employmentType: 'salaried',
      income: '',
      name: '',
      email: '',
      phone: '',
      city: '',
      carPrice: ''
    });
  };

  const calculateEMI = () => {
    const principal = parseFloat(formData.loanAmount) || 0;
    const rate = 8.5 / 12 / 100;
    const months = parseInt(formData.tenure) * 12;
    
    if (principal === 0 || months === 0) return 0;
    
    const emi = principal * rate * Math.pow(1 + rate, months) / 
                (Math.pow(1 + rate, months) - 1);
    return emi.toFixed(0);
  };

  const interestRate = 8.5;

  return (
    <div className="car-container">
      {/* <button className="car-back-btn" onClick={handleGoBack}>
        <span className="car-back-arrow">←</span>
        <span className="car-back-text">Back to Home</span>
        <div className="car-back-hover-effect"></div>
      </button> */}

      <div className="car-content">
        {/* Hero Section */}
        <div className="car-hero-section">
          <div className="car-hero-content">
            <h1 className="car-main-title">Drive Your Dream Car Today</h1>
            <p className="car-hero-subtitle">
              Get up to 100% financing with interest rates starting at 8.5% p.a.
            </p>
            <div className="car-hero-stats">
              <div className="car-stat">
                <span className="car-stat-value">₹10L+</span>
                <span className="car-stat-label">Average Loan Size</span>
              </div>
              <div className="car-stat">
                <span className="car-stat-value">24 Hrs</span>
                <span className="car-stat-label">Quick Approval</span>
              </div>
              <div className="car-stat">
                <span className="car-stat-value">15+</span>
                <span className="car-stat-label">Bank Partners</span>
              </div>
            </div>
          </div>
        </div>

        {/* EMI Calculator Section */}
        <div className="car-section car-emi-calculator">
          <div className="car-section-header">
            <h2 className="car-section-title">Calculate Your EMI</h2>
            <p className="car-section-subtitle">Adjust the sliders to find your perfect loan plan</p>
          </div>
          
          <div className="car-calculator-card">
            <div className="car-calculator-inputs">
              <div className="car-input-group">
                <label htmlFor="loanAmount">
                  Loan Amount: <span className="car-amount-display">₹{parseInt(formData.loanAmount).toLocaleString('en-IN')}</span>
                </label>
                <input
                  type="range"
                  id="loanAmount"
                  name="loanAmount"
                  min="100000"
                  max="5000000"
                  step="50000"
                  value={formData.loanAmount}
                  onChange={handleInputChange}
                  className="car-range-slider"
                />
                <div className="car-range-labels">
                  <span>₹1L</span>
                  <span>₹25L</span>
                  <span>₹50L</span>
                </div>
              </div>

              <div className="car-input-group">
                <label htmlFor="tenure">
                  Loan Tenure: <span className="car-tenure-display">{formData.tenure} Years</span>
                </label>
                <input
                  type="range"
                  id="tenure"
                  name="tenure"
                  min="1"
                  max="7"
                  step="1"
                  value={formData.tenure}
                  onChange={handleInputChange}
                  className="car-range-slider"
                />
                <div className="car-range-labels">
                  <span>1 Year</span>
                  <span>4 Years</span>
                  <span>7 Years</span>
                </div>
              </div>

              <div className="car-input-group">
                <label>Interest Rate</label>
                <div className="car-interest-rate">
                  <span className="car-rate-badge">{interestRate}% p.a.</span>
                  <span className="car-rate-note">Lowest rate available</span>
                </div>
              </div>
            </div>

            <div className="car-emi-result-card">
              <div className="car-emi-main">
                <div className="car-emi-label">Your Monthly EMI</div>
                <div className="car-emi-amount">₹{calculateEMI()}</div>
              </div>
              <div className="car-emi-details">
                <div className="car-emi-detail">
                  <span>Total Interest</span>
                  <span>₹{(calculateEMI() * parseInt(formData.tenure) * 12 - formData.loanAmount).toLocaleString('en-IN')}</span>
                </div>
                <div className="car-emi-detail">
                  <span>Total Payment</span>
                  <span>₹{(calculateEMI() * parseInt(formData.tenure) * 12).toLocaleString('en-IN')}</span>
                </div>
                <div className="car-emi-detail">
                  <span>Processing Fee</span>
                  <span>₹{(formData.loanAmount * 0.01).toLocaleString('en-IN')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features Section */}
        <div className="car-section car-features-section">
          <div className="car-section-header">
            <h2 className="car-section-title">Why Choose Our Car Loan</h2>
            <p className="car-section-subtitle">We make car financing simple and affordable</p>
          </div>
          
          <div className="car-features-grid">
            <div className="car-feature-card">
              <div className="car-feature-icon">💰</div>
              <h3>Lowest Rates</h3>
              <p>Starting from 8.5% p.a. interest rate</p>
            </div>
            <div className="car-feature-card">
              <div className="car-feature-icon">⚡</div>
              <h3>Fast Processing</h3>
              <p>Get approval within 24 hours</p>
            </div>
            <div className="car-feature-card">
              <div className="car-feature-icon">🏦</div>
              <h3>15+ Banks</h3>
              <p>Best offers from leading lenders</p>
            </div>
            <div className="car-feature-card">
              <div className="car-feature-icon">📄</div>
              <h3>Minimal Docs</h3>
              <p>Simple documentation process</p>
            </div>
            <div className="car-feature-card">
              <div className="car-feature-icon">🛡️</div>
              <h3>No Hidden Charges</h3>
              <p>Complete transparency in fees</p>
            </div>
            <div className="car-feature-card">
              <div className="car-feature-icon">🚗</div>
              <h3>100% Funding</h3>
              <p>Cover all on-road expenses</p>
            </div>
          </div>
        </div>

        {/* Application Form Section */}
        <div className="car-section car-application-section">
          <div className="car-section-header">
            <h2 className="car-section-title">Apply for Car Loan</h2>
            <p className="car-section-subtitle">Fill the form below and get instant approval</p>
          </div>
          
          <div className="car-form-card">
            <form onSubmit={handleSubmit} className="car-loan-form">
              <div className="car-form-row">
                <div className="car-form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>
                <div className="car-form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your email"
                  />
                </div>
              </div>
              
              <div className="car-form-row">
                <div className="car-form-group">
                  <label htmlFor="phone">Phone Number *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    placeholder="10-digit mobile number"
                  />
                </div>
                <div className="car-form-group">
                  <label htmlFor="city">City *</label>
                  <input
                    type="text"
                    id="city"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter your city"
                  />
                </div>
              </div>
              
              <div className="car-form-row">
                <div className="car-form-group">
                  <label htmlFor="income">Monthly Income (₹) *</label>
                  <input
                    type="number"
                    id="income"
                    name="income"
                    value={formData.income}
                    onChange={handleInputChange}
                    required
                    placeholder="e.g., 50,000"
                  />
                </div>
                <div className="car-form-group">
                  <label htmlFor="employmentType">Employment Type *</label>
                  <select
                    id="employmentType"
                    name="employmentType"
                    value={formData.employmentType}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="salaried">Salaried</option>
                    <option value="self-employed">Self Employed</option>
                    <option value="business">Business Owner</option>
                  </select>
                </div>
              </div>
              
              <div className="car-form-group car-full-width">
                <label htmlFor="carPrice">Car Price (Optional)</label>
                <input
                  type="number"
                  id="carPrice"
                  name="carPrice"
                  value={formData.carPrice}
                  onChange={handleInputChange}
                  placeholder="Enter expected car price"
                />
              </div>
              
              <div className="car-form-footer">
                <button type="submit" className="car-submit-btn">
                  Apply Now & Get Instant Approval
                  <span className="car-btn-arrow">→</span>
                </button>
                <p className="car-form-note">
                  By submitting, you agree to our Terms & Conditions and Privacy Policy
                </p>
              </div>
            </form>
          </div>
        </div>

        {/* Contact Section */}
        <div className="car-section car-contact-section">
          <div className="car-section-header">
            <h2 className="car-section-title">Get in Touch</h2>
            <p className="car-section-subtitle">Our loan experts are here to help you</p>
          </div>
          
          <div className="car-contact-cards">
            <div className="car-contact-card">
              <div className="car-contact-icon">📞</div>
              <h3>Call Us</h3>
              <a href="tel:18001234567" className="car-contact-link">9909002220</a>
              <p className="car-contact-hours">Mon-Sat: 9AM-9PM</p>
            </div>
            
            <div className="car-contact-card">
              <div className="car-contact-icon">📧</div>
              <h3>Email Us</h3>
              <a href="mailto:info@kfs09.in" className="car-contact-link">info@kfs09.in</a>
              <p className="car-contact-hours">Response within 2 hours</p>
            </div>
            
            <div className="car-contact-card">
              <div className="car-contact-icon">📍</div>
              <h3>Visit Us</h3>
              <p className="car-contact-address">123 Finance Street, Mumbai, Maharashtra 400001</p>
              <p className="car-contact-hours">By appointment only</p>
            </div>
          </div>
        </div>

        {/* Floating Elements */}
        <div className="car-floating-element car-el1">🚗</div>
        <div className="car-floating-element car-el2">💰</div>
        <div className="car-floating-element car-el3">🏎️</div>
      </div>
    </div>
  );
};

export default CarLoan;